//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TestingApiMethodComponentApi",

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    value: {},
  },

  components: {
    CustomAutocomplete: () => import("./CustomAutocomplete.vue")
  },

  methods: {
    change: function (value) {
      this.$emit('change', {
        name: this.item?.key,
        value: value?.value
      });
    }
  }
}
